import { slugRequest as http } from '@tencent/slug-request';
import {
  env,
  timeout,
  sandboxObj,
  loginType
} from '@/config/api';

// 设置请求的基础参数，env sandbox timeout
const setConf = (conf: ApiTypes.HttpRequestConfig) => {
  const { query, type } = conf;

  const newQuery = Object.assign({}, sandboxObj,loginType, query);
  conf.query = newQuery;

  if (type === 'api' || type === 'cdnJson') {
    conf.timeout = timeout;
  }

  return Object.assign({ env }, conf);
};


// 上报错误信息
const sentry = (path: string, err: object) => {
  try {
    Sentry.withScope((scope) => {
      // group errors together based on their request and response
      scope.setFingerprint([`request error:${path}`]);
      Sentry.captureException(`request error: ${path}${JSON.stringify(err)}`);
    });
  } catch (err) {
    Sentry.captureMessage(new Error(`sentry上报异常：${JSON.stringify(err)}`));
  }
};

const isWhite = (conf = { path: '', query: { p1: '' } }) => {
  const { path, query } = conf;

  // GICP上报
  if (path === '/wmp/v3.1/' && query.p1 === 'updateTotalPlay') return true;

  return false;
};


export function slugRequest<R extends object = {}>(conf: any): any {
  return new Promise((resolve, reject) => {
    http<R>(setConf(conf))
      .then((res: any) => {
        const { code } = res;
        // 兼容各种请求成功返回的状态
        if (code === 0 || code === '0' || code === 200) return resolve(res);

        // 判断是否为slugRequest未兼容处理的请求
        if (isWhite(conf)) return resolve({ code: 200, status: 'SUCCESS', data: null });

        reject(res);

        // 如返回频率限制的状态码不上报
        if (code === 7 && (conf.path === '/gingame/interactcenter/cancel_operation' || conf.path === '/gingame/interactcenter/operation')) return;

        sentry(conf.path || conf.url, res);
      })
      .catch((err) => {
        sentry(conf.path || conf.url, err);
        reject(err);
      });
  });
}
